import React from 'react';

export default function Disclaimer() {
  return (
    <section className="pt-28 pb-32 px-4 text-white bg-[#060b29] min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        {/* Heading */}
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-30">Disclaimer</h1>

        {/* Content */}
        <div className="space-y-8 text-left text-gray-300" style={{ fontSize: '20px' }}>
          <p>
            The financial data, insights, and tools provided through <strong className="text-white">PipPlus Tech</strong> are intended for
            general informational and investment purposes only. The content and outputs generated by Pipplus, whether
            automated or user-driven, should not be interpreted as personalized financial advice or recommendations for any
            specific investment strategy.
          </p>

          <p>
            PipPlus Tech does not offer tailored financial, legal, or tax advice. Users are strongly encouraged to consult
            with licensed financial advisors or other qualified professionals before making any investment, budgeting, or
            financial decisions based on information provided through Pipplus.
          </p>

          <p>
            Pipplus does not guarantee the accuracy, timeliness, or completeness of any data, projections, or analytics available
            through the platform. All financial decisions made using Pipplus are made at the user’s own discretion and risk. We
            accept no responsibility or liability for any loss, damage, or financial harm that may arise from the use of Pipplus
            services or reliance on its outputs.
          </p>

          <p>
            No warranties are made regarding the future performance of any financial product, asset, or investment model
            referenced or analyzed using PipPlus Tech. Past performance is not a reliable indicator of future outcomes.
          </p>

          <p>
            Pipplus may include or link to third-party tools, websites, or content as part of the user experience. We do not endorse,
            control, or guarantee the reliability of any third-party information or services and are not liable for any issues that may
            arise from their use.
          </p>

          <p>
            We reserve the right to modify, update, limit, or discontinue any features or services of PipPlus Tech at any time
            without notice. This disclaimer is subject to change without prior notice, and continued use of the platform implies
            acceptance of the most recent version.
          </p>

          <p>
            If you have questions or concerns about this disclaimer or the use of PipPlus Tech, please contact us directly.
          </p>
        </div>
      </div>
    </section>
  );
}
